import React, { Fragment } from 'react';
import ArticleHeader from 'components/general/ArticleHeader/ArticleHeader';
import Meta from 'components/general/Meta/Meta';
import MetaGrid from 'components/general/MetaGrid/MetaGrid';
import ContentMatrix from 'components/general/ContentMatrix/ContentMatrix';
import renderLoadState from 'utils/renderLoadState';
import ArticleHeaderSkeleton from 'components/general/ArticleHeader/ArticleHeaderSkeleton';
import SkeletonParagraph from 'components/general/Skeleton/SkeletonParagraph';
import Button from 'components/general/Button/Button';
import Icon from 'components/general/Icon/Icon';
import Badge from 'components/general/Badge/Badge';

const renderItem = ({ title, info }) => (
  <Meta title={title} info={info} />
);

const AlertBody = ({
  title,
  category,
  meta,
  tags,
  matrixBlocks,
  viewOnMap,
  loading,
}) => (
  <Fragment>
    {renderLoadState({
      LOADING: () => (
        <Fragment>
          <ArticleHeaderSkeleton />
          <SkeletonParagraph lines={6} />
        </Fragment>
      ),
      SUCCESS: () => (
        <Fragment>
          <ArticleHeader title={title} category={category} />
          {/* Wrapper to prevent interaction with spacing CSS */}
          <div>
            <MetaGrid
              items={meta}
              renderItem={renderItem}
            />
          </div>
          <ContentMatrix blocks={matrixBlocks} />
          {tags && (
            <div>
              <ul className="u-delist u-flex u-space">
                {tags.map(tag => (
                  <li key={tag.label}>
                    <Badge to={tag.to}>
                      <Icon
                        name="tag"
                        types={['push-right']}
                      />
                      {tag.label}
                    </Badge>
                  </li>
                ))}
              </ul>
            </div>
          )}
          {viewOnMap &&
            <div>
              {viewOnMap.map(action => (
                <Button
                  types={['icon']}
                  to={action.to}
                  onClick={action.onClick}
                >
                  <Icon name={action.icon} types={['push-right']} />
                  {action.title}
                </Button>
              ))}
            </div>
          }
        </Fragment>
      ),
    })(loading)}
  </Fragment>
);

export default AlertBody;
